import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/image 8.png";
import { FaXTwitter } from "react-icons/fa6";

import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";

const LandingPageFooter = () => {
  return (
    <footer className="text-slate-300">
      <hr className="border-slate-700 mb-8" />
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid gap-10 md:grid-cols-3">
          {/* Logo & Description */}
          <div>
            <Link to="/">
              <img
                src={logo}
                alt="Kanema Online"
                className="w-28 mb-4"
              />
            </Link>

            <p className="text-sm text-slate-400 leading-relaxed">
              Kanema Online is your destination for streaming
              Malawian and African entertainment anytime,
              anywhere.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">
              Quick Links
            </h3>

            <div className="flex flex-col gap-3">
              <Link
                to="/privacy-policy"
                className="hover:text-white transition"
              >
                Privacy Policy
              </Link>

              <Link
                to="/terms-of-use"
                className="hover:text-white transition"
              >
                Terms of Use
              </Link>

              <Link
                to="/help"
                className="hover:text-white transition"
              >
                Help & Support
              </Link>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-white font-semibold mb-4">
              Follow Us
            </h3>

            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/kanemaonline1"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white text-slate-900 flex items-center justify-center hover:scale-110 transition"
              >
                <FaFacebookF />
              </a>

              <a
                href="https://www.instagram.com/kanemaonline"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white text-slate-900 flex items-center justify-center hover:scale-110 transition"
              >
                <FaInstagram />
              </a>

              <a
                href="https://www.twitter.com/KanemaOnline"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white text-black hover:scale-110 transition-transform"
              >
                <FaXTwitter />
              </a>

              <a
                href="https://www.youtube.com/@kanemaonline"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white text-slate-900 flex items-center justify-center hover:scale-110 transition"
              >
                <FaYoutube />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800 py-4 text-center text-sm text-slate-500">
        © {new Date().getFullYear()} Static Computers Limited. All rights reserved.
      </div>
    </footer>
  );
};

export default LandingPageFooter;